import { IconProps } from '@/types/icons';

function CloseDrawerIcon(props: IconProps) {
  return (
    <svg width="11" height="12" viewBox="0 0 11 12" fill="none" {...props}>
      <path
        d="M9.89795 2.71875L6.6167 6L9.89795 9.3125C10.3042 9.6875 10.3042 10.3438 9.89795 10.7188C9.52295 11.125 8.8667 11.125 8.4917 10.7188L5.21045 7.4375L1.89795 10.7188C1.52295 11.125 0.866699 11.125 0.491699 10.7188C0.0854492 10.3438 0.0854492 9.6875 0.491699 9.3125L3.77295 6L0.491699 2.71875C0.0854492 2.34375 0.0854492 1.6875 0.491699 1.3125C0.866699 0.90625 1.52295 0.90625 1.89795 1.3125L5.21045 4.59375L8.4917 1.3125C8.8667 0.90625 9.52295 0.90625 9.89795 1.3125C10.3042 1.6875 10.3042 2.34375 9.89795 2.71875Z"
        fill="black"
      />
    </svg>
  );
}
export default CloseDrawerIcon;
